import { faChevronRight as farChevronRight } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faLightbulbOn as fadLightbulbOn } from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import autobind from "autobind-decorator";
import compact from "lodash/compact";
import deburr from "lodash/deburr";
import kebabCase from "lodash/kebabCase";
import React, { useContext } from "react";
import type { ReactNode } from "react";
import { Accordion, AccordionContext } from "react-bootstrap";

interface Props extends Record<string, any> {
	id?: string;
	className?: string;
	icon?: ReactNode;
	title: string;
	size?: "sm" | undefined;
	parentName?: string;
	merged?: boolean;
	showIconOnAllDevices?: boolean;
	titlePostFix?: ReactNode;
}

export class LandingAccordion extends React.PureComponent<Props> {
	public render(): ReactNode {
		const {
			title,
			id = kebabCase(deburr(title)),
			className,
			children,
			size,
			icon = <FontAwesomeIcon icon={fadLightbulbOn} />,
			merged = false,
			showIconOnAllDevices = false,
		} = this.props;
		const bodyClasses: string[] = ["accordion-body"];

		if (icon === "") {
			bodyClasses.push("px-3");
		}
		const accordionClasses = [className, "accordion-item", size && `accordion-item-${size}`];

		if (merged) {
			accordionClasses.push("merged");
		}

		return (
			<div className={compact(accordionClasses).join(" ")}>
				<this.ContextAwareToggle eventKey={id}>
					{icon && (
						<span className={`accordion-icon ${!showIconOnAllDevices && " d-none d-sm-inline"}`}>
							{icon}
						</span>
					)}
					{this.renderTitle()}
				</this.ContextAwareToggle>
				<Accordion.Collapse eventKey={id}>
					<div className={bodyClasses.join(" ")}>{children}</div>
				</Accordion.Collapse>
			</div>
		);
	}

	@autobind
	private ContextAwareToggle({ children, eventKey }) {
		const currentEventKey = useContext(AccordionContext);
		const isCurrentEventKey = currentEventKey === eventKey;

		return (
			<Accordion.Toggle
				eventKey={eventKey}
				className={`accordion-header text-reset${isCurrentEventKey ? " active" : ""}`}
				as="a"
				onClick={() => this.onAccordionClick(!isCurrentEventKey)}
			>
				{children}
				<FontAwesomeIcon icon={farChevronRight} rotation={90} />
			</Accordion.Toggle>
		);
	}

	private renderTitle(): ReactNode {
		const { title, titlePostFix } = this.props;

		if (titlePostFix) {
			return (
				<div className="d-flex align-items-center">
					<h3>{title}</h3>
					{titlePostFix}
				</div>
			);
		}

		return <h3>{title}</h3>;
	}

	@autobind
	private onAccordionClick(open: boolean): void {
		const { title, id = kebabCase(deburr(title)), parentName, callback } = this.props;

		if (callback) {
			callback(id);
		}

		if (open) {
			GoogleAnalytics4.sendEvent("BM_blockToggle", {
				tab: parentName,
				dropdownName: id,
			});
		}
	}
}
